/*eslint-disable*/
export default {
  imagePath: 'https://mge.szsoling.com/',
};
